import React, { Fragment, useEffect, useState } from "react";
import { Empty, Button, Badge, Spin, Select, Affix } from "antd";
import { useNavigate } from "react-router";
import moment from "moment";

import Navbar from "../../../atoms/navbar";
import Footer from "../../../atoms/footer";
import ImportantInfo from "../../../atoms/important-updates";
import API from "../../../services";
import HeaderFarms from "../../../utils/header_farms";
import { requestToken } from "../../../auth/AuthServices";
import { Loading, Report } from "notiflix";
import { useIsAuthenticated } from "@azure/msal-react";

import "./styles.css";

function PPEHistory() {
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();
  const [loading, setLoading] = useState(true);
  const [history, setHistory] = useState([]);
  const [filter, setFilter] = useState("Waiting Approval");

  const goDetail = (recId) => {
    if (!recId) return;
    navigate(`/ppe/view/${recId}`);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const accessToken = await requestToken();
        if (!accessToken) return;
        const res = await API.PPEHistory(HeaderFarms(accessToken));
        setHistory(res?.data || res || []);
      } catch (err) {
        console.error(err);
        Report.warning("Oops.. something wrong", "Sorry, this application is experiencing problems", "Okay");
      } finally {
        setLoading(false);
        Loading.remove();
      }
    };
    fetchData();
  }, [isAuthenticated]);

  return (
    <Fragment>
      <Navbar title="History" subtitle="PPE Request" back={true} navigate="/home" />
      <div className="container white-back-cr" style={{ minHeight: 500 }}>
        <ImportantInfo />
        <div className="container mt-3 p-3">
          <div className="row" style={{ marginBottom: "10px" }}>
            <div className="col-md-12 col-sm-12">
              <Affix offsetTop={10}>
                <div className="d-flex justify-content-between">
                  <div className="col-md-6 d-flex justify-content-start">
                    <Button type="primary" onClick={() => navigate("/ppe/create")} size="middle">
                      New PPE Request
                    </Button>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <label style={{ marginRight: 10, marginTop: 5 }}>Filter</label>
                    <Select
                      value={filter}
                      onChange={(v) => setFilter(v)}
                      options={[
                        { value: "Waiting Approval", label: "Waiting" },
                        { value: "Approved", label: "Approved" },
                        { value: "Reject", label: "Reject" },
                        { value: "Closed", label: "Closed" },
                        { value: "Cancel", label: "Cancel" },
                      ]}
                    />
                  </div>
                </div>
              </Affix>
            </div>
          </div>

          <div className="row mt-5">
            <div className="col-md-10 offset-md-1">
              {history && history.length > 0 ? (
                history.map((item, idx) => {
                  const status = item?.approval?.status || item?.status || "Unknown";
                  let ribbonColor = "#FF9900";
                  switch (status) {
                    case "Approved":
                      ribbonColor = "blue";
                      break;
                    case "Reject":
                    case "Rejected":
                      ribbonColor = "red";
                      break;
                    case "Closed":
                      ribbonColor = "green";
                      break;
                    default:
                      ribbonColor = "#FF9900";
                  }
                  const recId = item?.id_record || item?.record_id || item?._id || item?.id;
                  if (
                    (filter === "Waiting Approval" && status === "Waiting Approval") ||
                    (filter === "Approved" && status === "Approved") ||
                    (filter === "Reject" && (status === "Reject" || status === "Rejected")) ||
                    (filter === "Closed" && status === "Closed") ||
                    (filter === "Cancel" && status === "Cancel")
                  ) {
                    return (
                      <Badge.Ribbon key={idx} color={ribbonColor} text={status}>
                        <div className="list-style p-3 px-4 mb-3" onClick={() => goDetail(recId)}>
                          <div className="title mb-2">
                            <p className="fs-7 mb-0">{item?.submission_type || "PPE Request"}</p>
                          </div>
                          <div className="hour d-flex justify-content-between m-1">
                            <p className="fs-7" style={{ color: "#B7B7B7" }}>
                              {item?.created_at ? moment(item.created_at).format("LLL") : ""}
                            </p>
                          </div>
                        </div>
                      </Badge.Ribbon>
                    );
                  }
                  return null;
                })
              ) : !loading ? (
                <Empty className="mt-5" />
              ) : (
                <div className="mt-5 d-flex justify-content-center">
                  <Spin />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </Fragment>
  );
}

export default PPEHistory;
